import React, {FC} from 'react';
import '../Preferences/style.scss';
import './style.scss';
import TastesList from '../Preferences/TastesList';
import PreferencesTitle from '../Preferences/PreferencesTitle';
import {useHistory} from 'react-router-dom';
import WorkButton from '../form/WorkButton';
import HardnessList from '../Preferences/HardnessList';
import PreferencesHeader from "../Preferences/PreferencesHeader";
import {ITastes} from "../../constants/types";
import classNames from 'classnames';
import {IS_PLATFORM_IOS} from "../../services/utils/platforms";

interface ITastesTobacco {
    tastes: Array<ITastes>,
    activeTastesId: Array<number>,
    handleTastesId: any,
    activeHardnessId: any,
    handleHardnessId: number,
    pathUrl?: string,
    withoutBackButton?: boolean
}


const TastesTobacco: FC<ITastesTobacco> = ({
                                               tastes,
                                               activeTastesId,
                                               handleTastesId,
                                               activeHardnessId,
                                               handleHardnessId,
                                               pathUrl,
                                               withoutBackButton
                                           }) => {
    const history = useHistory();
    return (
        <div className="pref">
            <PreferencesHeader withoutBackButton={withoutBackButton}/>
            <div className={classNames({
                "preferences": true,
                "preferences--ios": IS_PLATFORM_IOS
            })}>
                <div className="preferences__wrapper">
                    <div className="preferences__container">
                        <PreferencesTitle>
                            1. Вкусы
                        </PreferencesTitle>
                        <TastesList
                            handleTastesId={handleTastesId}
                            tastes={tastes}
                            activeTastesId={activeTastesId}
                        />
                        <PreferencesTitle>
                            2. Насыщенность
                        </PreferencesTitle>
                        <HardnessList
                            activeHardnessId={activeHardnessId}
                            setActiveHardness={handleHardnessId}
                        />
                    </div>
                    <div className="preferences__button-container">
                        <WorkButton
                            isDisabled={!(!!activeHardnessId && activeTastesId.length > 0)}
                            onClick={() => history.push(pathUrl || '/start/brands')}
                        >
                            Продолжить
                        </WorkButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TastesTobacco;
